<template>
  <v-main>
    <v-container fluid>
      <!-- <v-row> -->
      <template v-if="isEnterMode">
        <pattern-card v-bind:pattern="pattern" v-bind:patternLogo="patternLogo" v-bind:fields="patternFields" />
      </template>
      <template v-else>
        <template v-if="isIndividual!==true">
          <FilterCard/>
        </template>
      </template>
      <!-- </v-row> -->
    </v-container>
  </v-main>
</template>

<script>

import { mapGetters } from "vuex";
import PatternCard from "@/components/PatternCard";
import FilterCard from "@/components/FilterCard";

export default {
  name: "AppContent",

  components: {
    PatternCard,
    FilterCard,
  },

  data: () => ({
  }),

  computed: {
    ...mapGetters({
      pattern: "patterns/selected",
      patternLogo: "patterns/selectedLogo",
      patternFields: "patterns/patternFields",
    }),

    ...mapGetters({
      username: "account/username",
      password: "account/password",
      userId: "account/userId",
      orgId: "account/orgId",
      online: "account/online",
      fflag: "account/fflag",
      isEnterMode: "account/isEnterMode",     // true - ввод заявок, false - просмотр
      isIndividual: "account/isIndividual",   // true - индивидуальный пользователь, false - групповой пользователь
    }),

  },

  mounted() {
    document.title = 'Аккредитация';
  }
};
</script>
